import Link from 'next/link'

export default function LinkButton({ children, size, color, disabled, onClick, ...linkProps }) {
  const handleClick = (event) => {
    if (disabled) {
      event.preventDefault()
      event.stopPropagation()
    }
    if (!!onClick && typeof onClick == 'function') {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <>
      <Link legacyBehavior {...linkProps}>
        <a onClick={handleClick} className={linkProps.className}>
          {children}
        </a>
      </Link>

      <style jsx>{`
        a {
          display: inline-block;
          min-width: 16rem;
          border-radius: 1.5625rem;
          color: var(--primary-button-color);
          font-weight: 700;
          transition: opacity 0.2s;
          text-align: center;

          &:active {
            opacity: 0.9;
          }
        }
      `}</style>

      <style jsx>{`
        a {
          padding: ${size === 'sm' ? '0 2.8rem' : '0 4.2rem'};
          height: ${size === 'sm' ? 2.6 : size === 'lg' ? 5 : 4.2}rem;
          border-radius: ${size === 'sm' ? 1.3 : size === 'lg' ? 2.5 : 2.1}rem;
          line-height: ${size === 'sm' ? 2.6 : size === 'lg' ? 5 : 4.2}rem;
          font-size: ${size === 'sm' ? 1.2 : size === 'lg' ? 2.2 : 1.8}rem;
          cursor: ${disabled ? 'not-allowed' : 'pointer'};
          opacity: ${disabled ? 0.7 : 1};
          background: ${color === 'secondary'
            ? 'var(--secondary-button-bg)'
            : color === 'alert'
            ? 'var(--alert-color)'
            : 'var(--primary-button-bg)'};
        }

        @media (max-width: 1024px) {
          a {
            min-width: unset;
            padding: ${size === 'sm' ? '0 2.8rem' : '0 3rem'};
            height: ${size === 'sm' ? 2.6 : 3.5}rem;
            line-height: ${size === 'sm' ? 2.6 : 3.5}rem;
            border-radius: ${size === 'sm' ? 1.3 : 1.8}rem;
            font-size: 1.2rem;
          }
        }
      `}</style>
    </>
  )
}
